import { NgModule } from '@angular/core';

import { SharedModule } from '@web/shared/shared.module';
import { DesktopRoutingModule } from './desktop-routing.module';

import { DesktopLayoutComponent } from './desktop-layout/desktop-layout.component';
import { HeaderComponent } from './desktop-layout/header/header.component';
import { SidebarMenuComponent } from './desktop-layout/sidebar-menu/sidebar-menu.component';
import { SidenavMenuComponent } from './desktop-layout/sidenav-menu/sidenav-menu.component';

@NgModule({
  imports: [SharedModule, DesktopRoutingModule],
  declarations: [DesktopLayoutComponent, HeaderComponent, SidebarMenuComponent, SidenavMenuComponent],
})
export class DesktopModule {}
